const currencyTypes = [
	{value: '1', id: '1', label: 'TRY (₺)', code: 'TRY', symbol: '₺', name: 'TL'},
	{value: '2', id: '2', label: 'EUR (€)', code: 'EUR', symbol: '€', name: 'EUR'},
	{value: '3', id: '3', label: 'USD ($)', code: 'USD', symbol: '$', name: 'USD'},
]

export default currencyTypes